export default {
  mainPage: '/',
  contactsPage: '/contacts',
  notFoundPage: '/404'
};
